import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Form, message, Select, Radio, Checkbox, DatePicker } from 'antd';
import PicUploader from 'component/pic-uploader/index'
import { saveHomeImgs } from 'service/statistic';
import moment from 'moment'
moment.locale('zh-cn')

const formItemLayout = {
  labelCol: {
    sm: { span: 4 },
  },
  wrapperCol: {
    sm: { span: 20 },
  },
};

class EditorModal extends React.Component {

  state = {
  }

  handleOk = () => {
    const { homeImgInfo } = this.props;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        // const { parentId, id } = homeImgInfo;
        // const avatar = values.avatar[0].key
        const { studentAdPicList, coachAdPicList } = values
        const _st = studentAdPicList.map(item => item.key)
        const _co = coachAdPicList.map(item => item.key)
        const params = {
          studentAdPicList: _st || [],
          coachAdPicList: _co || [],
          id: homeImgInfo.id
        }
        this.doSave(params)
      }
    });
  }

  doSave = async (params) => {
    const data = await saveHomeImgs(params)
    message.success('保存成功')
    this.handleCancel()
  }

  handleCancel = () => {
    this.props.handleCancelCreate();
  }

  render() {
    const { editorModalVisible, form, homeImgInfo } = this.props;
    const { getFieldDecorator } = form;

    return (
      <span>
        <Modal
          title="首页广告位"
          width={900}
          visible={editorModalVisible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
        >
          <Form>
            <Form.Item {...formItemLayout} label="教练端">
              {getFieldDecorator('coachAdPicList', {
                // rules: [{ required: true, message: '请上传！' }],
                initialValue:
                  homeImgInfo.coachAdPicList || []
              })(
                <PicUploader
                  value={homeImgInfo.coachAdPicList || []}
                  maxLength={100}
                  withOriginSize={false}
                  forBanner={true}
                  // onChange={(value) => {
                  //   this.changeHeader({
                  //     type: 'picture',
                  //     value: value[0]
                  //   })
                  // }}
                />
              )}
            </Form.Item>
            <Form.Item {...formItemLayout} label="学员端">
              {getFieldDecorator('studentAdPicList', {
                // rules: [{ required: true, message: '请上传全身照！' }],
                initialValue:
                  homeImgInfo.studentAdPicList || []
              })(
                <PicUploader
                  value={homeImgInfo.studentAdPicList || []}
                  maxLength={100}
                  withOriginSize={false}
                  forBanner={true}
                  // onChange={(value) => {
                  //   this.changeHeader({
                  //     type: 'picture',
                  //     value: value[0]
                  //   })
                  // }}
                />
              )}
            </Form.Item>
          </Form>
        </Modal>
      </span>
    );
  }
}

EditorModal.propTypes = {
  form: PropTypes.object.isRequired,
  editorModalVisible: PropTypes.bool.isRequired,
};

export default Form.create()(EditorModal);
